import React from "react";
import StoryPreview from "./story-preview";


function ResourcesStoriesGrid(props) {
  return (
    <div className="stories">
      <ul>
        {props.nodes && props.nodes.map(node => (
          <li key={node.id}>
            <StoryPreview {...node} directory={props.directory} language={props.language} />
          </li>
        ))}
      </ul>
    </div>
  );
}

ResourcesStoriesGrid.defaultProps = {
  title: "",
  nodes: [],
  browseMoreHref: ""
};

export default ResourcesStoriesGrid;
